import dashboard from './en/dashboard.json';
import translation from './en/translation.json';
import requests from './en/requests.json';
import login from './en/login.json';
import menu from './en/menu.json';
import finance from './en/finance.json';
import shipment from './en/shipment.json';
import tools from './en/tools.json';
import transport from './en/transport.json';
import report from './en/report.json';
import account from './en/account.json';
import admin from './en/admin.json';
import source_lang from './en/source_lang.json';
import purchase_order from './en/purchase_order.json';
import purchase_order_detail from './en/purchase_order_detail.json';
import associationEntities from './en/assiociationEntities.json';
import supplier_management from './en/supplier_management.json';
import analytics from './en/analytics.json';

let items = {
    ...dashboard, ...translation, ...requests, ...login, ...menu,
    ...report, ...account, ...admin,
    ...finance, ...shipment, ...tools, ...transport, ...source_lang,
    ...purchase_order, ...purchase_order_detail, ...associationEntities,
    ...supplier_management, ...analytics
}

export default items;